import { labelsOf } from '@feral/shared/options/core'
import { SPOT_CATEGORY_OPTIONS } from '@feral/shared/options/spots'

export const spotKey = (id: string) => ['spot', id] as const

// Labels, icons and hints for every option: options.ts in @feral/shared.
export const CATEGORY_LABEL = labelsOf(SPOT_CATEGORY_OPTIONS)
export { metres } from '../../lib/units.js'
export function ago(iso: string): string {
  const m = Math.max(1, Math.round((Date.now() - new Date(iso).getTime()) / 60_000))
  if (m < 60) return `${m}m`
  const h = Math.round(m / 60)
  if (h < 24) return `${h}h`
  const d = Math.round(h / 24)
  return d < 7 ? `${d}d` : `${Math.round(d / 7)}w`
}
